export const defaultGroupLevel = [
    {
      "groupByValue": "00: 30",
      "groupBy": {
        "groupBy": "creative_duration",
        "sortBy": "asc"
      },
      "currentLoc": [
        0
      ],
      "isOpen": true,
      "groupData": [
        {
          "groupByValue": "Pre-recorded Spot",
          "mentionGroupList": [
            {
              "mention_name": "TEMPLE/FOX",
              "stationLocalTime": "05/26/19 08:21 PM",
              "adsTypeName": "Pre-recorded Spot",
              "creative_duration": "00: 30",
              "station_name": "EFGH-FM ",
              "collected_date": "2019-05-27T00:21:54.000Z",
              "visits": 0,
              "new_users": 0,
              "status": 1,
              "media_type": 1,
              "media_id": 510008961,
              "ads_type_id": 2,
              "mention_id": "299808596",
              "stationTimezone": "America/New_York",
              "type_media": 1
            }
          ],
          "groupBy": {
            "groupBy": "adsTypeName",
            "sortBy": "asc"
          },
          "currentLoc": [
            0,
            0
          ]
        }
      ]
    }
  ];

export const groupLevel3 = [
    {
      "groupByValue": "00: 30",
      "groupBy": {
        "groupBy": "creative_duration",
        "sortBy": "asc"
      },
      "currentLoc": [
        0
      ],
      "isOpen": true,
      "groupData": [
        {
          "groupByValue": "EFGH-FM ",
          "groupBy": {
            "groupBy": "station_name",
            "sortBy": "asc"
          },
          "currentLoc": [
            0,
            0
          ],
          "isOpen": true,
          "groupData": [
            {
              "groupByValue": "05/26/19 08:21 PM",
              "mentionGroupList": [
                {
                  "mention_name": "TEMPLE/FOX",
                  "stationLocalTime": "05/26/19 08:21 PM",
                  "adsTypeName": "Pre-recorded Spot",
                  "creative_duration": "00: 30",
                  "station_name": "EFGH-FM ",
                  "collected_date": "2019-05-27T00:21:54.000Z",
                  "visits": 0,
                  "new_users": 0,
                  "status": 1,
                  "media_type": 1,
                  "media_id": 510008961,
                  "ads_type_id": 2,
                  "mention_id": "299808596",
                  "stationTimezone": "America/New_York",
                  "type_media": 1
                }
              ],
              "groupBy": {
                "groupBy": "stationLocalTime",
                "sortBy": "asc"
              },
              "currentLoc": [
                0,
                0,
                0
              ],
              "isOpen": false
            }
          ]
        }
      ]
    }
  ];

export const groupLevel4 = [
    {
      "groupByValue": "00: 30",
      "groupBy": {
        "groupBy": "creative_duration",
        "sortBy": "asc"
      },
      "currentLoc": [
        0
      ],
      "isOpen": true,
      "groupData": [
        {
          "groupByValue": "EFGH-FM ",
          "groupBy": {
            "groupBy": "station_name",
            "sortBy": "asc"
          },
          "currentLoc": [
            0,
            0
          ],
          "isOpen": true,
          "groupData": [
            {
              "groupByValue": "05/26/19 08:21 PM",
              "groupBy": {
                "groupBy": "stationLocalTime",
                "sortBy": "asc"
              },
              "currentLoc": [
                0,
                0,
                0
              ],
              "isOpen": true,
              "groupData": [
                {
                  "groupByValue": 0,
                  "mentionGroupList": [
                    {
                      "mention_name": "TEMPLE/FOX",
                      "stationLocalTime": "05/26/19 08:21 PM",
                      "adsTypeName": "Pre-recorded Spot",
                      "creative_duration": "00: 30",
                      "station_name": "EFGH-FM ",
                      "collected_date": "2019-05-27T00:21:54.000Z",
                      "visits": 0,
                      "new_users": 0,
                      "status": 1,
                      "media_type": 1,
                      "media_id": 510008961,
                      "ads_type_id": 2,
                      "mention_id": "299808596",
                      "stationTimezone": "America/New_York",
                      "type_media": 1
                    }
                  ],
                  "groupBy": {
                    "groupBy": "visits",
                    "sortBy": "asc"
                  },
                  "currentLoc": [
                    0,
                    0,
                    0,
                    0
                  ],
                  "isOpen": false
                }
              ]
            }
          ]
        }
      ]
    }
  ];

export const groupLevel5 = [
    {
      "groupByValue": "00: 30",
      "groupBy": {
        "groupBy": "creative_duration",
        "sortBy": "asc"
      },
      "currentLoc": [
        0
      ],
      "isOpen": true,
      "groupData": [
        {
          "groupByValue": "EFGH-FM ",
          "groupBy": {
            "groupBy": "station_name",
            "sortBy": "asc"
          },
          "currentLoc": [
            0,
            0
          ],
          "isOpen": true,
          "groupData": [
            {
              "groupByValue": "05/26/19 08:21 PM",
              "groupBy": {
                "groupBy": "stationLocalTime",
                "sortBy": "asc"
              },
              "currentLoc": [
                0,
                0,
                0
              ],
              "isOpen": true,
              "groupData": [
                {
                  "groupByValue": 0,
                  "groupBy": {
                    "groupBy": "visits",
                    "sortBy": "asc"
                  },
                  "currentLoc": [
                    0,
                    0,
                    0,
                    0
                  ],
                  "isOpen": true,
                  "groupData": [
                    {
                      "groupByValue": "0",
                      "mentionGroupList": [
                        {
                          "mention_name": "TEMPLE/FOX",
                          "stationLocalTime": "05/26/19 08:21 PM",
                          "adsTypeName": "Pre-recorded Spot",
                          "creative_duration": "00: 30",
                          "station_name": "EFGH-FM ",
                          "collected_date": "2019-05-27T00:21:54.000Z",
                          "visits": 0,
                          "new_users": 0,
                          "status": 1,
                          "media_type": 1,
                          "media_id": 510008961,
                          "ads_type_id": 2,
                          "mention_id": "299808596",
                          "stationTimezone": "America/New_York",
                          "type_media": 1
                        }
                      ],
                      "groupBy": {
                        "groupBy": "new_users",
                        "sortBy": "asc"
                      },
                      "currentLoc": [
                        0,
                        0,
                        0,
                        0,
                        0
                      ],
                      "isOpen": true
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ];